import { closeModal } from 'actions/modal';
import { useDispatch } from 'react-redux';

const useResultFailureLogic = () => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeModal());
  };

  return {
    handleClose,
  };
};

export default useResultFailureLogic;
